type ResultsRangeParams = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
};

export function getResultsRange({
  pageNumber,
  pageSize,
  totalCount,
}: ResultsRangeParams) {
  const first =
    totalCount === 0 ? 0 : Math.min((pageNumber - 1) * pageSize + 1, totalCount);
  const last = Math.min(pageNumber * pageSize, totalCount);

  return { first, last };
}
